import { Component, OnInit } from '@angular/core';
import { LocaleService } from 'src/app/services/locale.service';
import { AuthService } from 'src/app/api/auth.service';
import { Currency } from 'src/app/models/currency';
import { Observable } from 'rxjs';
import { CurrenciesService } from '../../api/currencies.service';

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss']
})
export class ExchangeComponent implements OnInit {
  lang: string;
  isLoggedIn: boolean;

  public currencies$: Observable<Currency[]> = this.currenciesService.getCrypto();

  constructor(
    private auth: AuthService,
    private localeService: LocaleService,
    private currenciesService: CurrenciesService
  ) {}

  ngOnInit() {
    this.lang = this.localeService.currentLocale;
    this.isLoggedIn = !!this.auth.getToken();
  }
}
